import React from "react";
import { FormControl, Input, useTheme, useMediaQuery } from "@mui/material";
import DatePicker from "react-datepicker";

const FormItemDatepicker = ({
  elementWidth,
  startDate,
  setStartDate,
  datepickerOpen,
  setDatepickerOpen,
  minDate,
  maxDate,
  openOnInput = false,
  filterDate = () => {
    return true;
  },
  excludedDates = [],
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleDateSelect = async (date) => {
    await setStartDate(date);
    setDatepickerOpen(false);
  };

  return (
    <FormControl
      onClick={openOnInput ? (e) => setDatepickerOpen(true) : () => {}}
      sx={{ width: {xs: "100%", md: "unset"} }}
    >
      <DatePicker
        selected={startDate}
        onChange={(date) => handleDateSelect(date)}
        onClickOutside={(e) => setDatepickerOpen(false)}
        minDate={minDate}
        maxDate={maxDate}
        customInput={
          <Input 
            variant="standard" 
            sx={{ 
              minWidth: elementWidth,
              fontSize: isMobile ? '18px' : 'inherit',
              fontWeight: isMobile ? 'bold' : 'normal',
            }} 
          />
        }
        open={datepickerOpen}
        filterDate={filterDate}
        excludeDates={excludedDates}
        disabled
        disabledKeyboardNavigation
      />
    </FormControl>
  );
};

export default FormItemDatepicker;
